var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HeaderFullscreen"},[_c('Iconfont',{staticClass:"alarm-tip",attrs:{"size":23,"name":_vm.iconName},on:{"click":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }